import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

import { IContract } from 'interfaces/Exemption';

import {
  IMyKnownError,
  REQUEST_LIFE_CICLE,
  IPaginatedListResponse,
  IListRequestParams,
} from 'interfaces/requests';

import { get, MICROSERVICES } from 'api';
import endpoints from './endpoints';
import { IExemptionListState } from './interfaces';
import { getAllContractsWithMainExemption } from './helpers';

export const loadExemptionListAction = createAsyncThunk<
  IExemptionListState,
  IListRequestParams | void,
  { rejectValue: IMyKnownError }
>('exemptionList/fetch', async (payload = undefined, { rejectWithValue }) => {
  try {
    const result = await get<IPaginatedListResponse<IContract>>(
      MICROSERVICES.CONTRACTS,
      {
        url: endpoints.exemptionList(),
        params: {
          ...payload,
          orderBy: payload ? payload.orderBy : 'cpfOwner',
          orderDirection: payload ? payload.orderDirection : 'asc',
          hasActiveExemption: true,
        },
      },
    );

    const exemptions = getAllContractsWithMainExemption(result.data.values);

    return {
      count: result.data.count,
      list: exemptions,
    } as IExemptionListState;
  } catch (error) {
    console.error('error at load exemption list', error);
    return rejectWithValue(error.message);
  }
});

const initialState = {
  loading: REQUEST_LIFE_CICLE.IDLE,
  list: [],
  count: 0,
} as IExemptionListState;

const exemptionListSlice = createSlice({
  name: 'exemptionList',
  initialState,
  reducers: {
    clearExemptionList: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(loadExemptionListAction.fulfilled, (state, action) => {
      state.count = action.payload.count;
      state.list = action.payload.list;
      state.loading = REQUEST_LIFE_CICLE.SUCCEEDED;
    });
    builder.addCase(loadExemptionListAction.pending, (state) => {
      state.loading = REQUEST_LIFE_CICLE.PENDING;
    });
    builder.addCase(loadExemptionListAction.rejected, (state) => {
      state.loading = REQUEST_LIFE_CICLE.FAILED;
    });
  },
});

const { reducer, actions } = exemptionListSlice;
export const { clearExemptionList } = actions;
export default reducer;
